module.exports = __webpack_public_path__ + "img/vertical_3_6_8019.96290a63.png";